import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-radio-input',
  templateUrl: './radio-input.component.html',
  styleUrls: ['./radio-input.component.scss']
})
export class RadioInputComponent implements OnInit {
  @Input() status: boolean;
  @Input() readonly: boolean=false;
  @Input() disabled: boolean=false;
  @Input() required: boolean=false;
  @Output() check:EventEmitter<boolean>=new EventEmitter() ;
  @Input() lableName:string;
  @Input() labelClass:string;
  @Input() id:string;
  @Input() name:string;
  
  constructor() { }

  ngOnInit(): void {
  }
}
